/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { Avatar, AvatarGroup, CircularProgress, CircularProgressLabel, Divider, Flex, Grid, Img, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaBullhorn, FaHeadset } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { PerfilColaborador } from '../../../components/PerfilColaborador/indesx'
import { WhiteContainer } from '../../../components/WhiteContainer'
import { FeedbackInicioResponse, iAvatarXInformacoes, iDashInicioResponse, iEtapaColaborador, iNineBoxAvaliacao, iPendencia, iPerfilColaborador } from '../../../interfaces'
import { appApi, urlSigah } from '../../../services/appApi'
import { parseJwt } from '../../../services/token'
import { formatarDataAno, GetMetaFinal, GetValorAcumulado, GetValorAcumuladoAteEsseMes, ObterCorPercentual, PropInvalida } from '../../../Utils/Helper'
import { Body } from '../../Layouts/Body'
import { ButtomInicial } from './Components/ButtomInicial'
import { CardEtapa } from './Components/CardEtapa'
import { ContainerPesquisa } from './Components/ContainerPesquisa'
import { ModalCanalDenuncia } from './Components/ModalCanalDenuncia'
import { ModalChamadoRh } from './Components/ModalChamadoRh'
import { ModalPesquisa } from './Components/ModalPesquisa'
import { ModalPrimeiroAcesso } from './Components/ModalPrimeiroAcesso'
import { ModalVideoIntroducao } from './Components/ModalVideoIntroducao'
import {
  HeadPreview, MainColumn, MainContainer,
  PreviewEtapaContainer
} from './styles'
import { Pesquisaimg } from './Svg/Pesquisaimg'

import { BsGraphUp } from 'react-icons/bs'
import { ButtonCmp } from '../../../components/ButtonCmp'
import LoadingContainer from '../../../components/LoadingContainer'
import { iIndicador } from '../../Indicadores/gestao'
import { ModalVisualizarParticipantes } from '../../Indicadores/gestao/components/ModalVisualizarParticipantes'
import { iDadoTabelaDashboardPDI } from '../../PDI/Dashboard/Individual'
import { iDadoTabela, Tabela } from '../../PDI/Dashboard/Individual/Components/Tabela'
import { iDadoTabelaAprovacao, TabelaAprovacao } from '../../RH/VisualizarTrilhaColaborador/Components/TabelaAprovacao'
import { CardReuniaoOne } from './Components/CardReuniaoOne'
import { ModalPDITrilha } from './Components/ModalPDI'
import { ModalReuniao } from './Components/ModalReuniao'
const IconeAviso = 'https://sigah.blob.core.windows.net/assets/front/ICONE-AVISO.svg'

interface iModelTrilha {
  id: string
  etapas: iEtapaColaborador[]
}

interface iConviteXPesquisa {
  tipo: number
  titulo: string
  link: string
  comunicacao?: iComunicacao
  dataInicio: string
  dataFim: string
}

interface iComunicacao {
  descricao: string
  uri: string
}

interface iAssinaturaPendente {
  cargoId: string
  nomeCargo: string
  expiraEm?: string
  solicitacaoVencida: boolean
}

export interface iDadoReuniao {
  id: string
  tipo: string
  status: number
  dataInicio: string
  duracao: number
  assunto: string
  descricao: string
  colaborador: iAvatarXInformacoes
  link?: string
}

interface iPerfilPDI {
  pdisAlteracao: iDadoTabelaDashboardPDI[]
  pdisEmAndamento: iDadoTabelaDashboardPDI[]
  pdiAprovacao: iDadoTabelaAprovacao[]
  pdiParaSubir: iDadoTabelaDashboardPDI[]
}

interface iModel {
  convites: iConviteXPesquisa[]
  pendencias: iPendencia[]
  indicador?: iIndicador
  indicadorPendente?: iIndicador
  pdi: iPerfilPDI
  processo?: iModelTrilha
  pdiAndamento: iDadoTabela[]
}

export const Painel: React.FC = () => {
  const nav = useNavigate()
  const [Model, setModel] = useState<iModel>()
  const [Reunioes, setReunioes] = useState<iDadoReuniao[]>([])
  const [AssinaturasPendentes, setAssinaturasPendentes] = useState<iAssinaturaPendente[]>([])
  const [ModalAcesso, setModalAcesso] = useState(false)
  const [Colaborador, setColaborador] = useState<iPerfilColaborador>()
  const [ModalReuniaoIsOpen, setModalReuniaoIsOpen] = useState(false)
  const [ModalPDIIsOpen, setModalPDIIsOpen] = useState(false)
  const [ModalPesquisaIsOpen, setModalPesquisaIsOpen] = useState(false)
  const [ModalIntroducaoIsOpen, setModalIntroducaoIsOpen] = useState(false)
  const [ModalChamadoIsOpen, setModalChamadoIsOpen] = useState(false)
  const [ModalDenunciaIsOpen, setModalDenunciaIsOpen] = useState(false)
  const [ViewTrilha, setViewTrilha] = useState(false)
  const [ModelFeedback, setModelFeedback] = useState<iDashInicioResponse>()
  const [ModelNineBox, setModelNineBox] = useState<iNineBoxAvaliacao>({
    comiteAtivo: false,
    nineBox: {
      id: '',
      padrao: false,
      areas: [],
      eixosX: [],
      eixosY: [],
      quadrantes: [],
      tags: [],
      squads: [],
      tipoMeta: 0,
      titulo: '',
      configuracaoEixoX: {
        descricao: '',
        titulo: ''
      },
      configuracaoEixoY: {
        descricao: '',
        titulo: ''
      }
    },
    comites: []
  })
  const [VisualizarParticipantes, setVisualizarParticipantes] = useState(false)
  const [VisualizarParticipantesPendente, setVisualizarParticipantesPendente] = useState(false)

  const [IsLoading, setIsLoading] = useState(false)
  const [IsLoadingPerfil, setIsLoadingPerfil] = useState(false)
  const [IsLoadingFeedbacks, setIsLoadingFeedbacks] = useState(false)
  const [ExpandirReunioes, setExpandirReunioes] = useState(false)

  const [Etapa, setEtapa] = useState<iEtapaColaborador>()

  function getTrilha(): void {
    setIsLoading(true)
    appApi.get('ProcessoOnboard/Trilha/v3').then(response => {
      if (!PropInvalida(response.data)) {
        setModel(response.data)
      }
      setIsLoading(false)
    }).catch(err => console.log(err))
  }

  function onClickEtapa(obj: iEtapaColaborador): any {
    if ((obj.tipo !== 2 && obj.tipo !== 7) && (obj.status !== 0 && obj.status !== 2 && obj.status !== 6 && obj.status !== 7)) {
      return () => { }
    }
    setEtapa(obj)
    if (obj.tipo === 1) {
      return nav(`/Colaborador/Integracao/${obj.interacoes[0].idExterno}/Etapa/${obj.id}`)
    } else if (obj.tipo === 3) {
      if (obj.status === 2) {
        return nav(`/Colaborador/Imersao/${obj.interacoes[0].idExterno}/Etapa/${obj.id}/Visualizar`)
      } else {
        return nav(`/Colaborador/Imersao/${obj.interacoes[0].idExterno}/Etapa/${obj.id}`)
      }
    } else if (obj.tipo === 4 || obj.tipo === 5) {
      return setModalPesquisaIsOpen(true)
    } else if (obj.tipo === 6) {
      return window.open(`${urlSigah}/PesquisasPEC/f/${obj.conviteId}`, '_blank')
    } else if (obj.tipo === 2 || obj.tipo === 7 || obj.tipo === 10) {
      return setModalReuniaoIsOpen(true)
    } else if (obj.tipo === 9) {
      return setModalPDIIsOpen(true)
    } else {
      return () => { }
    }
  }

  function getColaboador(): void {
    setIsLoadingPerfil(true)
    appApi.get('Colaborador/Perfil')
      .then(response => { setColaborador(response.data); ObterNineBox(response.data.id) })
      .catch(err => console.log(err))
      .finally(() => setIsLoadingPerfil(false))
  }

  function getFeedbacks(): void {
    setIsLoadingFeedbacks(true)
    appApi.get('FeedbackPersonalizado/Colaborador')
      .then(response => { setModelFeedback(response.data) })
      .catch(err => console.log(err))
      .finally(() => setIsLoadingFeedbacks(false))
  }

  function getReunioes(): void {
    appApi.get('ReuniaoOne/Principal')
      .then(res => {
        if (res.status === 200) {
          setReunioes(res.data)
        }
      })
      .catch(err => console.log(err))
  }

  function getAssinaturasPendentes(): void {
    appApi.get<iAssinaturaPendente[]>('api/Assinatura/MinhasPendencias')
      .then(res => setAssinaturasPendentes(res.data))
      .catch(err => console.log(err))
  }

  function Load(): void {
    getTrilha()
    getColaboador()
    getFeedbacks()
  }

  function PostChamado(texto: string): void {
    const form = {
      texto: texto
    }
    appApi.post('Chamado', form)
      .then(res => {
        setModalChamadoIsOpen(false)
        // console.log(res.data)
      }
      ).catch(err => console.log(err))
  }

  function PostDenuncia(texto: string): void {
    const form = {
      texto: texto,
      avatar: ''
    }
    appApi.post('api/ChamadosOuvidoria', form)
      .then(res => {
        setModalDenunciaIsOpen(false)
        console.log(res.data)
      }
      ).catch(err => console.log(err))
  }

  function ConcluirPrimeiroAcesso(pronome: string, avatar?: string): void {
    const form = {
      avatar: avatar,
      pronome: pronome
    }

    appApi.patch('EtapaColaborador/PrimeiroAcesso', form)
      .then(res => {
        localStorage.setItem('token', res.data)
        if (Model?.processo) {
          getTrilha()
        }
        Load()
      })
      .catch(err => console.log(err))
  }

  function onCloseModalAcesso(): void {
    setModalAcesso(false)
    setModalIntroducaoIsOpen(true)
  }

  function TemAtividades(): boolean {
    return !(Model?.pendencias.every(r => r.nomePendencia === 'Não há atividades disponíveis no momento') &&
      Model?.pdi?.pdiAprovacao?.length === 0 &&
      Model?.pdi?.pdisEmAndamento?.length === 0 &&
      Reunioes.length === 0 &&
      Model.convites.length === 0)
  }

  function ObterNineBox(colabId: string): void {
    appApi.get(`NineBox/Colaborador/${colabId ?? ''}`)
      .then(res => setModelNineBox(res.data))
      .catch(err => console.log(err))
  }

  function OnGetFeedback(feedback?: FeedbackInicioResponse): any {
    if (!feedback) return <></>

    return <Flex flexDir={'column'} gap='.75rem' mt={'1.5rem'}>
      <Flex justifyContent={'space-between'} alignItems={'center'} gap={'2rem'}>
        <Flex gap='.325rem' lineHeight={'14px'} flexDir={'column'}>
          <Flex fontSize={'16px'} fontWeight={600} gap={'.325rem'}>{feedback.nome}</Flex>
          <Flex fontSize={'14px'} gap={'.325rem'} fontWeight={'400'}>Itens concluídos <strong style={{ color: 'var(--Green2)' }}>{feedback.itensConcluidos}/{feedback.itensTotais}</strong></Flex>
        </Flex>
        <Flex gap={'1rem'}>
          <Flex justifyContent={'center'} gap={'1rem'}>
            <Flex gap={'.325rem'} alignItems={'center'} border={'1px solid var(--Rosa)'} bg={'var(--RosaOpacoBg)'} borderRadius={'.25rem'} p={'.5rem .75rem'}>
              <Avatar src={feedback.participante.avatar} size={'sm'}/>
              <Flex flexDir={'column'} lineHeight={'14px'}>
                <Flex fontSize={'12px'} fontWeight={'400'}>Participante</Flex>
                <Flex fontSize={'14px'} fontWeight={'600'}>{feedback.participante.nome}</Flex>
              </Flex>
            </Flex>
            <Flex gap={'.325rem'} alignItems={'center'} border={'1px solid var(--Rosa)'} bg={'var(--RosaOpacoBg)'} borderRadius={'.25rem'} p={'.5rem .75rem'}>
              <Avatar src={feedback.responsavel.avatar} size={'sm'}/>
              <Flex flexDir={'column'} lineHeight={'14px'}>
                <Flex fontSize={'12px'} fontWeight={'400'}>Responsável</Flex>
                <Flex fontSize={'14px'} fontWeight={'600'}>{feedback.responsavel.nome}</Flex>
              </Flex>
            </Flex>
          </Flex>
          <ButtonCmp onClick={() => nav(`/Feedback/${feedback?.id}/Dashboard/${feedback.participante.id}/Participante`)} VarColor='Green2'>Ver mais</ButtonCmp>
        </Flex>
      </Flex>
      <Divider borderColor={'var(--Azul)'} opacity={'.8'} my={'.5rem'}/>
      <Flex flexDir={'column'} gap={'1rem'}>
        {feedback.pendentes?.map(e => {
          return (<Flex p={'.5rem 3rem'} w={'100%'} bg={'var(--AzulOpacoBg)'} border={'1px solid var(--c5)'} alignItems={'center'} boxShadow={'var(--SombraBackground)'} gap={'2rem'}>
            <Flex flexDir={'column'} lineHeight={'1rem'} gap={'.325rem'}>
              <Text fontSize={'.875rem'} fontWeight={400}>{e.titulo}</Text>
              <Text fontSize={'1rem'} fontWeight={600}>{e.mensagem}</Text>
            </Flex>
            <Divider orientation='vertical' h={'3rem'} borderColor={'black'} opacity={'.9'}/>
            {<ButtonCmp VarColor='Rosa' onClick={() => { window.location.href = e.url ?? '' }}>Realizar item</ButtonCmp>}
          </Flex>)
        })}
        {(!feedback.pendentes || feedback.pendentes?.length === 0) && <Flex border={'1px solid var(--c6)'} bg={'var(--c2)'} fontWeight={600} alignItems={'center'} justifyContent={'center'} p={'1rem'}>Nenhum item pendente para realizar</Flex>}
      </Flex>
    </Flex>
  }

  const ValorAcumulado = GetValorAcumulado(Model?.indicador?.periodos ?? [], Model?.indicador?.tipoMeta ?? 0)
  const ValorAcumuladoPendente = GetValorAcumulado(Model?.indicadorPendente?.periodos ?? [], Model?.indicadorPendente?.tipoMeta ?? 0)
  const ProgressoMeta = GetValorAcumulado(Model?.indicador?.periodos ?? [], Model?.indicador?.tipoMeta ?? 0, Model?.indicador?.meta, Model?.indicador?.metaInversa)
  const ProgressoMetaPendente = GetValorAcumulado(Model?.indicadorPendente?.periodos ?? [], Model?.indicadorPendente?.tipoMeta ?? 0, Model?.indicadorPendente?.meta, Model?.indicadorPendente?.metaInversa)

  useEffect(() => {
    Load()
    getReunioes()
    getAssinaturasPendentes()
    const val = parseJwt().pa
    if (val === '' || val === 'False') {
      setModalAcesso(true)
    }
  }, [])

  return (
    <Body>
      {ModalReuniaoIsOpen &&
        <ModalReuniao
          onRequestClose={() => setModalReuniaoIsOpen(false)}
          etapa={Etapa}
        />
      }

      {Model?.indicadorPendente && <ModalVisualizarParticipantes
        isOpen={VisualizarParticipantesPendente}
        onClose={() => setVisualizarParticipantesPendente(false)}
        onUpdate={() => {}}
        indicadorId={''}
        responsavel={Model?.indicadorPendente?.responsavel}
        participantes={Model?.indicadorPendente?.participantes}
        isResponsavel={Model?.indicadorPendente?.isResponsavel ?? false}
      />}

      {Model?.indicador && <ModalVisualizarParticipantes
        isOpen={VisualizarParticipantes}
        onClose={() => setVisualizarParticipantes(false)}
        onUpdate={() => {}}
        indicadorId={''}
        responsavel={Model?.indicador?.responsavel}
        participantes={Model?.indicador?.participantes}
        isResponsavel={Model?.indicador?.isResponsavel ?? false}
      />}

      {ModalPesquisaIsOpen &&
        <ModalPesquisa
          onRequestClose={() => setModalPesquisaIsOpen(false)}
          etapa={Etapa}
        />
      }

      {ModalPDIIsOpen &&
        <ModalPDITrilha
          onRequestClose={() => setModalPDIIsOpen(false)}
          etapa={Etapa}
        />
      }

      {ModalChamadoIsOpen &&
        <ModalChamadoRh
          isOpen
          onConfirm={PostChamado}
          onRequestClose={() => setModalChamadoIsOpen(false)}
        />
      }

      {ModalDenunciaIsOpen &&
        <ModalCanalDenuncia
          isOpen
          onConfirm={PostDenuncia}
          onRequestClose={() => setModalDenunciaIsOpen(false)}
        />
      }

      {ModalAcesso &&
        <ModalPrimeiroAcesso
          isOpen
          OnCloseModal={onCloseModalAcesso}
          onConcluir={ConcluirPrimeiroAcesso}
        />
      }

      {ModalIntroducaoIsOpen &&
        <ModalVideoIntroducao
          isOpen
          onClose={() => setModalIntroducaoIsOpen(false)}
        />
      }

      <Flex>
        <PerfilColaborador
          Colaborador={Colaborador ?? {} as iPerfilColaborador}
          margin='0 1rem 0 0'
          reload={getColaboador}
          nineBox={ModelNineBox.nineBox}
          IsLoading={IsLoadingPerfil}
        />
        {!ViewTrilha && <MainContainer>
          <LoadingContainer loading={IsLoading} linhas={26}>
            {Model && (
              <>
                {!(Model?.pendencias.every(r => r.nomePendencia === 'Não há atividades disponíveis no momento')) &&
                  <WhiteContainer>
                    <Grid templateColumns='repeat(2, 1fr)' gap={'.625rem'}>
                      {
                        Model?.pendencias.map((e, i) => {
                          if (e.nomePendencia !== 'Não há atividades disponíveis no momento') {
                            return (
                              <ButtomInicial
                                key={i}
                                pendencia={e}
                                clickExterno={() => setViewTrilha(true)}
                              />
                            )
                          }
                          return null
                        })
                      }
                    </Grid>
                  </WhiteContainer>
                }

                {!TemAtividades() && <WhiteContainer
                  styles={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Flex fontWeight={'600'} minH={'24rem'} justifyContent={'center'} alignItems={'center'}><h3>Sem atividades disponíveis no momento!</h3></Flex>
                </WhiteContainer>
                }

                {AssinaturasPendentes.length > 0 && <WhiteContainer>
                  <Flex flexDir={'column'} gap={'.75rem'}>
                    <Flex alignItems={'center'} gap='.325rem'>
                      <Img w={'1.5rem'} h='1.5rem' src={IconeAviso}/>
                      <h3>Cargos aguardando a sua assinatura</h3>
                    </Flex>
                    <Text fontSize={'14px'}>O código de assinatura foi enviado para o seu e-mail. Por segurança, ele não é exibido no sistema: consulte a sua caixa de entrada e informe o código na tela de assinatura.</Text>
                    {AssinaturasPendentes.map(a => (
                      <Flex key={a.cargoId} justifyContent={'space-between'} alignItems={'center'} gap={'1rem'}>
                        <Flex flexDir={'column'}>
                          <Text fontSize={'16px'}>Cargo: <strong style={{ fontWeight: 900 }}>{a.nomeCargo}</strong></Text>
                          {a.expiraEm && <Text fontSize={'12px'} color={a.solicitacaoVencida ? 'red.500' : 'gray.600'}>
                            {a.solicitacaoVencida ? 'Código expirado em ' : 'Código válido até '}{new Date(a.expiraEm).toLocaleDateString('pt-BR')}
                            {a.solicitacaoVencida && '. Solicite um novo código ao responsável.'}
                          </Text>}
                        </Flex>
                        <ButtonCmp onClick={() => nav(`/Descritivo/Assinatura/LinhaDoTempo/${a.cargoId}`)} VarColor='Green2'>Ir para a assinatura</ButtonCmp>
                      </Flex>
                    ))}
                  </Flex>
                </WhiteContainer>}

                <LoadingContainer linhas={14} loading={IsLoadingFeedbacks}>
                  {ModelFeedback?.meuFeedback && <WhiteContainer
                    styles={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '.75rem' }}>
                    <h3>Feedback em andamento</h3>
                    {OnGetFeedback(ModelFeedback?.meuFeedback)}
                  </WhiteContainer>}
                  {ModelFeedback?.feedbacksComAtividade && ModelFeedback.feedbacksComAtividade.length > 0 && <WhiteContainer
                    styles={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '1rem' }}>
                    <h3>Feedbacks com ações pendentes</h3>
                    {ModelFeedback.feedbacksComAtividade?.map((e, i) => {
                      return <Flex flexDir={'column'} gap={'1rem'}>
                        {OnGetFeedback(e)}
                        {ModelFeedback.feedbacksComAtividade && i !== (ModelFeedback.feedbacksComAtividade?.length - 1) &&
                        <Divider borderColor={'var(--c6)'} opacity={'.9'} mt={'1.125rem'} mb={'.75rem'}/>}
                      </Flex>
                    })}
                  </WhiteContainer>}
                </LoadingContainer>

                {Model.indicadorPendente && <WhiteContainer
                  styles={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Flex flexDir={'column'} gap='.75rem'>
                      <Flex justifyContent={'space-between'} alignItems={'center'}>
                        <Flex alignItems={'center'} gap='.325rem'>
                          <Img w={'1.5rem'} h='1.5rem' src={IconeAviso}/>
                          <h3>Indicador pendente para aprovar</h3>
                        </Flex>
                        <ButtonCmp onClick={() => nav('/Desempenho/Indicadores/Adm')} VarColor='Green2'>Seguir para aprovação</ButtonCmp>
                      </Flex>
                      <Flex>
                        <Flex flexDir={'column'} flex={1}>
                          <Text fontSize={'18px'}>Nome: <strong style={{ fontWeight: 900 }}>{Model.indicadorPendente.nome}</strong></Text>
                          <Text fontSize={'14px'}>Data de início: <strong>{Model.indicadorPendente.dataInicio ? formatarDataAno(Model.indicadorPendente.dataInicio.slice(0, 7)) : 'Indefinido'}</strong></Text>
                          <Text fontSize={'14px'}>Prazo de conclusão: <strong>{Model.indicadorPendente.prazo ? formatarDataAno(Model.indicadorPendente.prazo.slice(0, 7)) : 'Indefinido'}</strong></Text>
                        </Flex>
                        <Flex gap={'1rem'} alignItems={'center'} w={'50%'} justifyContent='end'>
                          <Flex flexDir={'column'} justifyContent='center' h={'100%'}>
                            <Text fontSize={'14px'}>Meta: <strong>{GetMetaFinal(Model.indicadorPendente)}</strong></Text>
                            <Text fontSize={'14px'}>Valor acumulado: <strong>{GetValorAcumuladoAteEsseMes(Model.indicadorPendente, ValorAcumuladoPendente)}</strong></Text>
                          </Flex>
                          <Flex flexDir={'column'}>
                            <CircularProgress value={Math.min(100, ProgressoMetaPendente)} color={ObterCorPercentual(ProgressoMetaPendente, ProgressoMetaPendente === 0)} size={'65px'} height={'70px'}>
                              <CircularProgressLabel mt={'.35rem'} fontSize={'14px'}>{ProgressoMetaPendente === 0 ? 'N/A' : `${ProgressoMetaPendente.toFixed(1)}%`}</CircularProgressLabel>
                            </CircularProgress>
                          </Flex>
                        </Flex>
                      </Flex>
                      {Model.indicadorPendente.responsavel && Model.indicadorPendente.participantes && Model.indicadorPendente.participantes?.length > 0 && <Flex gap={'.75rem'} alignItems={'center'}>
                        <Text fontWeight={700} fontSize={'16px'}>Participantes: </Text>
                        <Flex gap={'.75rem'}>
                          <AvatarGroup size='sm' max={15}>
                            <Avatar src={Model.indicadorPendente.responsavel?.avatar}/>
                            {Model.indicadorPendente.participantes?.filter(p => p.id !== Model.indicadorPendente?.responsavel?.id).map(p => {
                              return (
                                <Avatar src={p.avatar}/>
                              )
                            })}
                          </AvatarGroup>
                          <ButtonCmp onClick={() => setVisualizarParticipantesPendente(true)} VarColor='Rosa'>Ver participantes</ButtonCmp>
                        </Flex>
                      </Flex>}
                    </Flex>
                </WhiteContainer>
                }

                {Model.indicador && <WhiteContainer
                  styles={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Flex flexDir={'column'} gap='.75rem'>
                      <Flex justifyContent={'space-between'} alignItems={'center'}>
                        <Flex alignItems={'center'} gap='.325rem'>
                          <BsGraphUp color='var(--Green2)' size={18}/>
                          <h3>Indicador ativo</h3>
                        </Flex>
                        <ButtonCmp onClick={() => nav('/Desempenho/Indicadores')} VarColor='Green2'>Ver mais</ButtonCmp>
                      </Flex>
                      <Flex>
                        <Flex flexDir={'column'} flex={1}>
                          <Text fontSize={'18px'}>Nome: <strong style={{ fontWeight: 900 }}>{Model.indicador.nome}</strong></Text>
                          <Text fontSize={'14px'}>Data de início: <strong>{Model.indicador.dataInicio ? formatarDataAno(Model.indicador.dataInicio.slice(0, 7)) : 'Indefinido'}</strong></Text>
                          <Text fontSize={'14px'}>Prazo de conclusão: <strong>{Model.indicador.prazo ? formatarDataAno(Model.indicador.prazo.slice(0, 7)) : 'Indefinido'}</strong></Text>
                        </Flex>
                        <Flex gap={'1rem'} alignItems={'center'} w={'50%'} justifyContent='end'>
                          <Flex flexDir={'column'} justifyContent='center' h={'100%'}>
                            <Text fontSize={'14px'}>Meta: <strong>{GetMetaFinal(Model.indicador)}</strong></Text>
                            <Text fontSize={'14px'}>Valor acumulado: <strong>{GetValorAcumuladoAteEsseMes(Model.indicador, ValorAcumulado)}</strong></Text>
                          </Flex>
                          <Flex flexDir={'column'}>
                            <CircularProgress value={Math.min(100, ProgressoMeta)} color={ObterCorPercentual(ProgressoMeta, ProgressoMeta === 0)} size={'65px'} height={'70px'}>
                              <CircularProgressLabel mt={'.35rem'} fontSize={'14px'}>{ProgressoMeta === 0 ? 'N/A' : `${ProgressoMeta.toFixed(1)}%`}</CircularProgressLabel>
                            </CircularProgress>
                          </Flex>
                        </Flex>
                      </Flex>
                      {Model.indicador.responsavel && Model.indicador.participantes && Model.indicador.participantes?.length > 0 && <Flex gap={'.75rem'} alignItems={'center'}>
                        <Text fontWeight={700} fontSize={'16px'}>Participantes: </Text>
                        <Flex gap={'.75rem'}>
                          <AvatarGroup size='sm' max={15}>
                            <Avatar src={Model.indicador.responsavel?.avatar}/>
                            {Model.indicador.participantes?.filter(p => p.id !== Model.indicador?.responsavel?.id).map(p => {
                              return (
                                <Avatar src={p.avatar}/>
                              )
                            })}
                          </AvatarGroup>
                          <ButtonCmp onClick={() => setVisualizarParticipantes(true)} VarColor='Rosa'>Ver participantes</ButtonCmp>
                        </Flex>
                      </Flex>}
                    </Flex>
                </WhiteContainer>
                }

                {Model?.pdi?.pdiAprovacao?.length > 0 && (
                  <WhiteContainer>
                    <h3>PDI aguardando aprovação</h3>
                    <Flex marginTop={'.5rem'} flexDir={'column'}>
                      <TabelaAprovacao
                        slice={4}
                        dados={Model?.pdi.pdiAprovacao}
                      />
                    </Flex>
                  </WhiteContainer>
                )}

                {Model.pdi?.pdisEmAndamento?.length > 0 && (
                  <WhiteContainer>
                    <Tabela
                      iconSize='1.8rem'
                      fontSize='14px'
                      slice={4}
                      dados={Model.pdi.pdisEmAndamento}
                      modoHome = {true}
                    />
                  </WhiteContainer>
                )}

                {Model.pdi?.pdisAlteracao?.length > 0 && (
                  <WhiteContainer>
                    <Tabela
                      iconSize='1.8rem'
                      fontSize='12px'
                      slice={4}
                      dados={Model.pdi.pdisAlteracao}
                      variant='editar'
                    />
                  </WhiteContainer>
                )}

                {Model.pdi?.pdiParaSubir?.length > 0 && (
                  <WhiteContainer>
                    <Tabela
                      iconSize='1.8rem'
                      fontSize='12px'
                      slice={4}
                      dados={Model.pdi.pdiParaSubir}
                      variant='criar'
                    />
                  </WhiteContainer>
                )}

                {Reunioes.length > 0 &&
                  <WhiteContainer>
                    <h3>Reuniões 1:1</h3>

                    <Flex mt={'1rem'} gap={'.75rem'} flexDir={'column'}>
                      {Reunioes.filter(e => e.status === 0).length > 0 &&
                        <Flex flexDir={'column'} gap={'.25rem'}>
                          <Text fontWeight={'bold'}>Convites pendentes</Text>
                          <Flex flexDir={'column'} gap={'.75rem'}>
                            {Reunioes.filter(e => e.status === 0).map((e, i) => {
                              return (
                                <CardReuniaoOne key={i} model={e} reload={getReunioes} />
                              )
                            })}
                          </Flex>
                        </Flex>
                      }

                      {Reunioes.filter(e => e.status === 1).length > 0 &&
                        <Flex flexDir={'column'} gap={'.25rem'}>
                          <Text fontWeight={'bold'}>Em andamento</Text>
                          <Flex flexDir={'column'} gap={'.75rem'}>
                            {Reunioes.filter(e => e.status === 1).map((e, i) => {
                              return (
                                <CardReuniaoOne key={i} model={e} reload={getReunioes} />
                              )
                            })}
                          </Flex>
                        </Flex>
                      }

                      {Reunioes.filter(e => e.status === 2).length > 0 &&
                        <Flex flexDir={'column'} gap={'.25rem'}>
                          <Text fontWeight={'bold'}>Atrasadas</Text>
                          <Flex flexDir={'column'} gap={'.75rem'}>
                            {Reunioes.filter(e => e.status === 2).map((e, i) => {
                              return (
                                <CardReuniaoOne key={i} model={e} reload={getReunioes} />
                              )
                            })}
                          </Flex>
                        </Flex>
                      }

                      {Reunioes.filter(e => e.status === 3).length > 0 &&
                        <Flex flexDir={'column'} gap={'.25rem'}>
                          <Text fontWeight={'bold'}>Próximas reuniões</Text>
                          <Flex flexDir={'column'} gap={'.75rem'}>
                            {Reunioes.filter(e => e.status === 3).map((e, i) => {
                              if (!ExpandirReunioes && i > 1) return null

                              return (
                                <CardReuniaoOne key={i} model={e} reload={getReunioes} />
                              )
                            })}
                          </Flex>

                          {!ExpandirReunioes && Reunioes.filter(e => e.status === 3).length > 2 &&
                            <Text
                              cursor={'pointer'}
                              onClick={() => setExpandirReunioes(true)}
                              fontWeight={'700'}
                              textDecoration='underline'
                              color={'var(--Azul)'}
                            >Mostrar todas</Text>
                          }

                          {ExpandirReunioes && Reunioes.filter(e => e.status === 3).length > 2 &&
                            <Text
                              cursor={'pointer'}
                              onClick={() => setExpandirReunioes(false)}
                              fontWeight={'700'}
                              textDecoration='underline'
                              color={'var(--Azul)'}
                            >Ocultar</Text>
                          }
                        </Flex>
                      }

                      {Reunioes.filter(e => e.status === 4).length > 0 &&
                        <Flex flexDir={'column'} gap={'.25rem'}>
                          <Text fontWeight={'bold'}>Pendentes para configuração</Text>
                          <Flex flexDir={'column'} gap={'.75rem'}>
                            {Reunioes.filter(e => e.status === 4).map((e, i) => {
                              return (
                                <CardReuniaoOne key={i} model={e} reload={getReunioes} />
                              )
                            })}
                          </Flex>
                        </Flex>
                      }
                    </Flex>
                  </WhiteContainer>
                }

                {Model?.processo && (
                  <WhiteContainer>
                    <HeadPreview>
                      <Pesquisaimg />
                      <span>Você tem uma etapa a ser realizada...</span>
                    </HeadPreview>
                    <PreviewEtapaContainer>
                      {
                        Model.processo.etapas.filter(e => e.status !== 2).slice(0, 2).map((e: iEtapaColaborador, i) => {
                          return (
                            <CardEtapa
                              key={i}
                              etapa={e}
                              last={true}
                              onClick={() => onClickEtapa(e)}
                            />
                          )
                        })
                      }
                    </PreviewEtapaContainer>
                    <ButtonCmp
                      OutlineColor='Green2'
                      mt={'1rem'}
                      onClick={() => setViewTrilha(true)}
                    >Clique e veja toda sua linha do tempo</ButtonCmp>
                  </WhiteContainer>
                )}

                {Model.convites.length > 0 &&
                  <Grid gridTemplateColumns={'repeat(2, 1fr)'} gap={'1rem 1rem'}>
                    {Model.convites?.map((e, i) => {
                      return (
                        <WhiteContainer>
                          <ContainerPesquisa key={i} convite={e} />
                        </WhiteContainer>
                      )
                    })}
                  </Grid>
                }

              </>
            )}
            </LoadingContainer>
          </MainContainer>}
          {ViewTrilha && (
            <MainColumn padding='1rem 1rem' width='60%'>
              <Flex justifyContent={'space-between'} alignItems={'center'} mb={'1rem'}>
                <Flex flexDir={'column'}>
                  <h3>Trilha em andamento</h3>
                  <span style={{ fontSize: '.875rem', lineHeight: '.875rem' }}>Acompanhe cada etapa a ser realizada e que você já realizou</span>
                </Flex>
                <Flex gap={'.5rem'}>
                  <ButtonCmp VarColor='c5' onClick={() => setViewTrilha(false)}>Voltar</ButtonCmp>
                  <ButtonCmp onClick={() => setModalChamadoIsOpen(true)} VarColor='Green2' leftIcon={<FaHeadset/>}> Abrir chamado com RH</ButtonCmp>
                  <ButtonCmp onClick={() => setModalDenunciaIsOpen(true)} VarColor='Rosa' leftIcon={<FaBullhorn/>}> Abrir denúncia</ButtonCmp>
                </Flex>
              </Flex>
              {
                (Model?.processo) && (
                  <Flex flexDir={'column'}>
                    {
                      Model?.processo.etapas.map((e: iEtapaColaborador, i) => {
                        return (
                          <CardEtapa
                            key={i}
                            etapa={e}
                            last={i + 1 === Model?.processo?.etapas?.length ?? 0}
                            onClick={() => onClickEtapa(e)}
                          />
                        )
                      })
                    }
                  </Flex>
                )
              }
            </MainColumn>
          )}
      </Flex>
    </Body>
  )
}
